module.exports = __webpack_public_path__ + "media/images/consumer/icons/appstore-59701c809576ba13444cabba59579264.png";